import { ReactNode } from 'react';
import { Drawer } from '@mui/material';
import { CoreBox } from '@youscience/core';
import CloseIcon from '@images/close.svg?react';
import { sxStyles } from './FilterDrawer.styles';

interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const FilterDrawer = ({ open, onClose, children }: FilterDrawerProps) => (
  <Drawer sx={sxStyles.drawerPaper} anchor="top" open={open} onClose={onClose}>
    {children}
    <CoreBox
      onClick={onClose}
      sx={{
        position: 'absolute',
        top: 16,
        right: 16,
        cursor: 'pointer',
      }}
    >
      <CloseIcon />
    </CoreBox>
  </Drawer>
);
